export default {
  name: 'listcounter',
  props: {
    listData: {
      type: Object,
      required: true
    }
  },
  computed: {
    listCounterClasses () {
      return ` bg-${this.listData.color} `
    }
  }
}
